import React from 'react';
import { Button, FormControl, Grid, makeStyles, TextField, Typography } from '@material-ui/core';

import { UserModel } from '../../../Models/UserModel';
import { UserContext } from '../UserContext';
import AuthService from '../../../Services/AuthService';
import { validateEmail } from '../../../shared/operators';
import { PasswordFields } from '../components/PasswordFields';
import { AxiosResponse } from 'axios';

export interface IFirstAccessProps {
    onClick: () => void
    onBack: () => void
}

const useStyles = makeStyles(() => ({
    container: {
        width: '430px'
    },
    itens: {
        marginTop: '20px'
    },
    textLink: {
        marginBottom: '36px',
        marginTop: '12px',
        cursor: 'pointer'
    }
}));


export function FirstAccess({ onClick, onBack }: IFirstAccessProps) {
    const classes = useStyles();

    const userContext = React.useContext(UserContext);
    const [errorEmail, setErrorEmail] = React.useState<boolean>(false);

    const handleChange = (prop: keyof UserModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        userContext.setUser({ ...userContext.user, [prop]: event.target.value });
    };


    const validEmail = () => {
        setErrorEmail(!validateEmail(userContext.user.email ?? ''));
    };

    const getDisabledSubmit = () => {
        return errorEmail || !userContext.user.email || userContext.disableSubmit;
    };

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
            className={classes.container}>
            <Typography variant='subtitle2' className={classes.textLink} onClick={onBack}>
                Voltar
            </Typography>
            <Typography variant='h3' color="textPrimary">
                Primeiro acesso
            </Typography>
            <Typography variant='body1' color="textSecondary">
                Para o seu primeiro acesso, insira o seu email de acesso e crie uma nova senha.
            </Typography>
            <FormControl fullWidth >
                <TextField
                    id="user-metric"
                    label="Email"
                    variant="outlined"
                    className={classes.itens}
                    value={userContext.user.email}
                    onBlur={validEmail}
                    error={errorEmail}
                    helperText={errorEmail ? (userContext.user.email ? 'O email inserido não é válido.' : 'Campo obrigatório') : ''}
                    onChange={ handleChange('email') } />
                <PasswordFields />
            </FormControl>
            <Button
                size="large"
                variant="contained"
                color="primary"
                fullWidth
                className={classes.itens}
                onClick={onClick}
                disabled={ getDisabledSubmit() }>
                SALVAR SENHA E ACESSAR
            </Button>
        </Grid>
    );
}